<template>
	<div class="">
		<div class="">
			<slot name="icon"></slot>
		</div>
		<div class="">
			<slot name="title"></slot>
			<slot name="subtitle"></slot>
		</div>
	</div>
</template>

<script setup></script>
